import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TableComponent } from '../../../core/table/table.component';
import { ColumnComponent } from '../../../core/table/column.component';
import { ToolbarButtonComponent } from '../../../core/buttons/toolbar-button.component';
import { AgencyFilter } from '../../../../models/api/reports/agency-filter';
import { dialogPaginatorDropdownStyles } from '../../../core/table/dialog-paginator-dropdown.styles';

@Component({
  selector: 'app-agencies',
  standalone: true,
  host: {
    '[class.dialog-table-paginator-dropdown-self]':
      "paginatorDropdownAppendTo === 'self'",
  },
  imports: [TableComponent, ColumnComponent, ToolbarButtonComponent],
  template: `<app-table
    [dataSource]="dataSource"
    recordLabel="agency"
    recordLabelPlural="agencies"
    [showSelection]="showSelection"
    selectionKey="agencyNumber"
    dataKey="agencyNumber"
    [pageSize]="5"
    [paginatorDropdownAppendTo]="paginatorDropdownAppendTo"
    [isRowSelectable]="isRowSelectable"
    (selectedEvent)="onSelectedChanged($event)"
  >
    <app-column name="agencyNumber" label="Agency number" />
    <app-column name="agencyName" label="Agency name" />
    <app-column name="city" label="City" />
    <app-column name="state" label="State" />
    @if (showRemove) {
      <app-column name="action" label="Remove">
        <ng-template #value let-data>
          <app-toolbar-button
            type="Compact"
            icon="fa-light fa-trash-can"
            (click)="remove(data)"
            ariaLabel="Remove agency"
          />
        </ng-template>
      </app-column>
    }
  </app-table>`,
  styles: dialogPaginatorDropdownStyles,
})
export class AgenciesComponent {
  @Input()
  dataSource: AgencyFilter[] = [];

  @Input()
  paginatorDropdownAppendTo: 'body' | 'self' = 'body';

  @Input()
  showRemove = true;

  @Input()
  showSelection = false;

  @Input()
  isRowSelectable: (row: AgencyFilter) => boolean = () => true;

  @Output()
  selected = new EventEmitter<AgencyFilter[]>();

  @Output()
  removed = new EventEmitter<AgencyFilter>();

  onSelectedChanged(event: AgencyFilter[]) {
    this.selected.emit(event);
  }

  remove(row: AgencyFilter) {
    this.removed.emit(row);
  }
}
